"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var QuickOptionSearchEntry_1 = require("./QuickOptionSearchEntry");
var Toggle_1 = require("office-ui-fabric-react/lib/Toggle");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Tooltip_1 = require("office-ui-fabric-react/lib/Tooltip");
var onQuickOptionToggle_1 = require("owa-options-actions/lib/onQuickOptionToggle");
var styles = require('./QuickOptions.scss');
var QuickOptionEntry = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptionEntry, _super);
    function QuickOptionEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onToggle = function (isToggledOn) {
            onQuickOptionToggle_1.default(isToggledOn, _this.props.option);
        };
        return _this;
    }
    QuickOptionEntry.prototype.render = function () {
        var option = this.props.option;
        var quickOptionSettings = option.quickOptionSettings, key = option.key;
        if (!quickOptionSettings) {
            // No render was provided. Instead, render as link to full options
            return React.createElement(QuickOptionSearchEntry_1.default, tslib_1.__assign({}, this.props));
        }
        var optionAriaId = "options-quick-" + key;
        var optionTooltipId = optionAriaId + "-tooltip";
        var rendering = quickOptionSettings.rendering, tooltip = quickOptionSettings.tooltip, customTitle = quickOptionSettings.customTitle;
        var _a = tooltip || {}, tooltipStringKey = _a.tooltipStringKey, shouldHideTooltip = _a.shouldHideTooltip;
        var render = rendering.render;
        var _b = rendering, isToggleOn = _b.isToggleOn, onToggle = _b.onToggle, hideToggle = _b.hideToggle;
        return (React.createElement("div", { className: styles.quickSetting },
            React.createElement("div", { id: optionAriaId, className: styles.quickSettingHeader, role: "heading", "aria-level": 3 },
                React.createElement("div", { className: styles.title },
                    React.createElement("span", null, owa_options_strings_1.default[customTitle || option.titleStringKey]),
                    tooltip &&
                        (!shouldHideTooltip || !shouldHideTooltip()) && (React.createElement(Tooltip_1.TooltipHost, { content: owa_options_strings_1.default[tooltipStringKey], id: optionTooltipId },
                        React.createElement(Icon_1.Icon, { iconName: "Info" /* Info */, className: styles.infoIcon })))),
                isToggleOn &&
                    onToggle &&
                    (!hideToggle || !hideToggle()) && (React.createElement(Toggle_1.Toggle, { checked: isToggleOn(), onChanged: this.onToggle, className: styles.toggle, onAriaLabel: owa_common_strings_1.default.toggle_on, offAriaLabel: owa_common_strings_1.default.toggle_off }))),
            render &&
                render({
                    headerAriaId: optionAriaId,
                })));
    };
    QuickOptionEntry = tslib_1.__decorate([
        mobx_react_1.observer
    ], QuickOptionEntry);
    return QuickOptionEntry;
}(React.Component));
exports.default = QuickOptionEntry;
//# sourceMappingURL=QuickOptionEntry.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/quick/QuickOptionEntry.js
// module id = 4912
// module chunks = 2